<div class="chat-box">
  <h3 class="chat-box__header">{{'ChatBox.Header' | translate}}</h3>
  <app-chat-box-messages class="chat-box__body" [messages]="messages"></app-chat-box-messages>
  <app-chat-box-input class="chat-box__footer" (sendText)="sendText($event)"></app-chat-box-input>
</div>